import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';

interface IProps {
    text: string;
}

const PageHeader: FC<IProps> = ({ text }) => {
    return (
        <div className="ms-Grid-row ms-slideRightIn40">
            <div style={{ padding: '10px', textAlign: 'center' }} className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <fabric.Text style={{ fontWeight: 'lighter' }} variant="xxLargePlus">
                    {text}
                </fabric.Text>
            </div>
        </div>
    );
};

export default PageHeader;
